import React from "react";
import { ReactController } from "./react_controller";
import { GregPrimerTheme } from "@getregistered/greg-editors";
import { OperationsTray } from "../components/OperationsTray";

export class OperationsTrayController extends ReactController {
  connect() {
    this.root.render(
      <GregPrimerTheme>
        <OperationsTray {...this.propsValue} />
      </GregPrimerTheme>
    );
  }
}
